import { z } from "zod"
import {
  BaseCustomerSchema,
  CustomersFilterBySchema,
  CustomersSortSchema,
} from "../../customers/dtos"
import { validatePhoneNumber } from "../../shared/filter_dtos"
import { PaginationSchema } from "../../shared/pagination_dtos"
import { QuerySchema } from "../../shared/query_dtos"

export const GetBackofficeCustomersSchema = z.object({
  companyId: z.string().transform(BigInt),
  ...PaginationSchema.extend(QuerySchema.shape)
    .extend(CustomersSortSchema.shape)
    .extend(CustomersFilterBySchema.shape).shape,
})

export const GetBackofficeCustomerParamsSchema = z.object({
  id: z.string().transform(BigInt),
})

export const UpsertBackofficeCustomerBodySchema = BaseCustomerSchema.extend(
  z.object({
    companyId: z.string().transform(BigInt),
  }).shape,
).refine(
  ({ phone, country, locale }) =>
    validatePhoneNumber(
      phone ?? null,
      (country as string | null | undefined) ?? null,
      (locale as string | null | undefined) ?? null,
    ),
  {
    path: ["phone"],
    message: "Invalid phone number",
  },
)
